import { gql } from 'graphql-tag'

import { addressFields } from '../addressFields'

export const UPDATE_ADDRESS = gql`
  mutation updateAddress($addressId: ID!, $addressInput: UpdateAddressInput!, $clientId: ID!, $consumerId: ID!) {
    updateAddress(addressId: $addressId, addressInput: $addressInput, clientId: $clientId, consumerId: $consumerId) {
      ...AddressFields
    }
  }
  ${addressFields}
`
